<template>
  <div id="user_bind1">
    <!-- <div class="top_title fixed">{{ step != 3 ? '游戏账号绑定':'角色绑定' }}</div> -->
    <div v-if="step != 3">
      <div class="game_choose" @click="openGamePop">
        <img class="icon" :src="gameIcon" alt="" />
        <div class="name">{{ gameName }}</div>
      </div>
      <div class="content">
        <div class="bind_tabs">
          <div :class="['bind_tab', { active: bindType === 'account' }]" @click="changeBindType('account')">账号绑定</div>
          <div :class="['bind_tab', { active: bindType === 'mobile' }]" @click="changeBindType('mobile')">手机号绑定</div>
        </div>
        <el-form
          :model="actionData"
          ref="form"
          :show-message="showMessage"
          v-show="step == 1"
          @submit.native.prevent
        >
          <el-form-item prop="plat_id" :rules="rules.plat">
            <div class="prefix">请选择渠道</div>
            <el-select placeholder="请选择渠道" v-model="actionData.plat_id" popper-class="el_plat_select">
              <el-option v-for="(item, i) in platList"  :value="item.id" :key="i"
                :label="item.name">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="account" :rules="rules.account">
            <div class="prefix">{{ bindType === 'mobile' ? '手机号' : '账户' }}</div>
            <el-input
              v-model="actionData.account"
              class="lwc_phone"
              :placeholder="bindType === 'mobile' ? '请输入手机号' : '请输入账户'"
              ref="account"
              :maxlength="bindType === 'mobile' ? 11 : undefined"
              @input="handleAccountInput"
            ></el-input>
          </el-form-item>
        </el-form>


        <div class="tip" v-show="bindType === 'account'">
          <p>如无法确定账号，可前往游戏左上角小球内查看并复制账号，或选择<i>手机号绑定</i>进行账号绑定。</p>
        </div>
        <div class="bind_btns">
          <el-button
            class="next_step"
            type="primary"
            :loading="loading > 0"
            @click="next"
            >下一步</el-button
          >
        </div>
      </div>
    </div>
    <div id="user_bind2" v-else>
      <div class="content">
            <div class="box">
                <van-icon name="passed" class="success"/>
                <div>绑定成功</div>
                <p>游戏账号：{{ game_account }}</p>
                <p>平台账号：{{ account }}</p>
            </div>
        </div>
        <el-button class="confirm" type="primary" @click="confirm">确定</el-button>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
export default {
  data() {
    return {
      actionData: {
        account: "",
        // password: "",
        // code: "",
        plat_id: ''
      },
      actionData2: {
        code: "",
      },
      isdisabled: false,
      buttonName: "获取验证码",
      time: 58,
      loading: 0,
      showMessage: true,
      showMessage2: true,
      step: 1,
      msg: '',
      game_account: '',
      account: '',
      platList: [],
      bindType: 'account',
      
    };
  },
  computed: {
    rules() {
      const { account, captcha, password, plat, mobile } = this.$store.getters.rules;
      return {
        account: this.bindType === 'mobile' ? mobile : account,
        code: captcha,
        password,
        plat
      };
    },
    gameIcon() {
      return this.$store.state.gameIcon;
    },
    gameId() {
      return this.$store.state.gameId;
    },
    gameName() {
      return this.$store.state.gameName;
    },
  },
  mounted() {
    // this.$RModal.bindgameacc({
    //   noheader:true,
    //   selection: {
    //     account: this.actionData.account,
    //     password: this.actionData.password,
    //     app_id: this.gameId,
    //     platform_id: this.actionData.plat_id
    //   },
    //   onSuccess: (e) => {
    //     this.game_account = e.game_account
    //     this.account = e.account
    //     this.step = 3;
    //   }
    // })
  },
  methods: {
    changeBindType(type) {
      if (this.bindType === type) return
      this.bindType = type
      this.actionData.account = ''
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate && this.$refs.form.clearValidate()
      })
    },
    handleAccountInput(val) {
      if (this.bindType === 'mobile') {
        this.actionData.account = (val || '').replace(/\D/g, '').slice(0, 11)
        return
      }
      this.actionData.account = val
    },
    //获取渠道信息
    getPlatList(app_id) {
      this.actionData.plat_id = ''
      this.platList = []
      this.$Ajax('user-info/get-platforms',{app_id},'get').then(rs => {
        if(rs.code == 200) {
          
          this.platList = rs.data
        }
      })
    },
    //打开选择游戏
    openGamePop() {
      this.$filterPop({
        type: "game",
        notUserRoleList: true
      });
    },
    sendCode() {
      var that = this;
      $(".lwc_code input").focus();
      if (this.actionData.account == "") {
        this.$refs.account.handleBlur();
        return;
      }
      this.isdisabled = true;
      this.$Ajax("user-info/sendcode-by-account", {
        account: this.actionData.account,
        password: this.actionData.password,
        app_id: this.gameId,
        platform_id: this.actionData.plat_id
      }).then(rs => {
        if (rs.code == 200) {
          this.$toast({
            message: rs.msg,
          });
          this.buttonName = "重新发送(59)";
          let interval = window.setInterval(function () {
            that.buttonName = "重新发送(" + that.time + ")";
            that.time--;
            if (that.time < 0) {
              that.buttonName = "重新发送";
              that.time = 58;
              that.isdisabled = false;
              window.clearInterval(interval);
            }
          }, 1000);
        }else {
          that.buttonName = "重新发送";
          that.time = 58;
          that.isdisabled = false;
        }
      });
    },
    pre() {
      if (this.step == 2) {
        this.step = 1;
      }
    },
    next() {
      var that = this
      if (this.step == 1) {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.loading++;
            const requestUrl = this.bindType === 'mobile' ? 'v2/user/find-by-mobile' : 'v2/user/find-by-account'
            const requestData = {
              app_id: this.gameId,
              platform_id: this.actionData.plat_id,
            }
            if (this.bindType === 'mobile') {
              requestData.mobile = this.actionData.account
            } else {
              requestData.account = this.actionData.account
            }
            this.$Ajax(requestUrl, requestData).then(rs => {
              if(rs.code == 200) {
                if (this.bindType === 'mobile') {
                  this.$RModal.bindgameacc({
                    noheader:true,
                    selection: {
                      account: rs.data.account,
                      app_id: this.gameId,
                      platform_id: this.actionData.plat_id,
                      mobile: requestData.mobile,
                      user_id: rs.data.user_id,
                      jh_user_id: rs.data.jh_user_id
                    },
                    onSuccess: (e) => {
                      this.game_account = e.game_account
                      this.account = e.account
                      this.step = 3;
                    }
                  })
                  return
                }
                if(rs.data.phone == '') {
                  this.$RModal.bindgameacc2({
                    noheader:true,
                    selection: {
                      account: this.actionData.account,
                      app_id: this.gameId,
                      platform_id: this.actionData.plat_id,
                      user_id: rs.data.user_id,
                      jh_user_id: rs.data.jh_user_id
                    },
                    onSuccess: (e) => {
                      this.game_account = e.game_account
                      this.account = e.account
                      this.step = 3;
                    }
                  })
                }else {
                  this.$RModal.bindgameacc({
                    noheader:true,
                    selection: {
                      account: this.actionData.account,
                      app_id: this.gameId,
                      platform_id: this.actionData.plat_id,
                      mobile: rs.data.phone,
                      user_id: rs.data.user_id,
                      jh_user_id: rs.data.jh_user_id
                    },
                    onSuccess: (e) => {
                      this.game_account = e.game_account
                      this.account = e.account
                      this.step = 3;
                    }
                  })
                }
              }
            }).finally(() => {
              setTimeout(() => {
                that.loading = 0;
              }, 1000);
            });

            // this.$Ajax("user-info/bind-account",{
            //   account: this.actionData.account,
            //   password: this.actionData.password,
            //   app_id: this.gameId,
            //   platform_id: this.actionData.plat_id
            // }).then(rs => {
            //   if(rs.code == 203) {
            //     this.step = 2;
            //     this.msg = rs.data.msg
            //     this.loading = 0;
            //     this.$Message.success({
            //       message: rs.msg,
            //     });
            //   }else if(rs.code == 200) {
            //     this.step = 3;
            //     this.game_account = rs.data.game_account
            //     this.account = rs.data.account
            //   }else {
            //     this.$Message.error(rs.msg)
            //   }
            // }).finally(() => {
            //   setTimeout(() => {
            //     that.loading = 0;
            //   }, 1000);
            // });
          }
        });
      } else if (this.step == 2) {
        this.$refs.form2.validate(valid => {
          if (valid) {
            this.loading++
            this.$Ajax("user-info/bind-account",{
              account: this.actionData.account,
              password: this.actionData.password,
              app_id: this.gameId,
              code: this.actionData2.code,
              platform_id: this.actionData.plat_id
            }).then(rs => {
              if(rs.code == 200) {
                this.step = 3;
                this.game_account = rs.data.game_account
                this.account = rs.data.account
              }else {
                this.$Message.error(rs.msg)
              }
            }).finally(() => {
              setTimeout(() => {
                that.loading = 0;
              }, 2000);
            });
          }
        });
      }
    },
    confirm() {
      this.$router.go(-1)
    }
  },
  watch: {
    '$store.state.gameId': {
      immediate: true,
      handler(e) {
        this.getPlatList(e)
      }
    }
  },
};
</script>
<style lang="less" socped>
#user_bind1 {
  padding-right: 1.2rem;
  padding-top: 1rem;
  position: relative;

  .game_choose {
    position: absolute;
    right: 0;
    top: 2rem;
    width: 9.5rem;
    height: 3.6rem;
    background-color: var(--chooseBg);
    // border: 0.15rem solid var(--borderColor);
    border-right: none;
    border-top-left-radius: 10rem;
    border-bottom-left-radius: 10rem;
    display: flex;
    align-items: center;
    padding-left: 0.1rem;
    cursor: pointer;
    z-index: 10;
    overflow: hidden;
    .icon {
      width: 3.4rem;
      height: 3.4rem;
      border-radius: 50%;
    }

    .name {
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      text-align: center;
      font-size: 1.2rem;
      transform: scale(0.98);
    }
  }

  .content {
    padding-top: 6rem;
    .bind_tabs {
      display: flex;
      background-color: #fff;
      border-radius: 1rem;
      padding: 0 1rem;
      margin-bottom: 1rem;
      .bind_tab {
        flex: 1;
        height: 4.4rem;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 1.5rem;
        color: #666;
        cursor: pointer;
        position: relative;
        font-weight: 700;
        &.active {
          color: var(--theme);
          &::after {
            content: '';
            position: absolute;
            left: 50%;
            bottom: .6rem;
            transform: translateX(-50%);
            width: 4.2rem;
            height: .3rem;
            background-color: var(--theme);
            border-radius: 10rem;
          }
        }
      }
    }
    .el-select {
      width: 100%;
    }
    .msg {
      text-align: center;
      font-size: 1.6rem;
    }
    .el-form {
      padding: 1.5rem 1rem;
      background-color: #fff;
      border-radius: 1rem;
      .el-form-item {
        margin-bottom: 1rem;
      }

      .el-form-item__content {
        line-height: 1.5;
        display: flex;
        align-items: center;
        .prefix {
          width: 8rem;
          padding: 0;
          font-size: 1.6rem;
          text-align: justify;
          text-align-last: justify;
          margin-right: 1.4rem;
        }
        .el-select,
        .el-input {
          flex: 1;
          .el-input__inner {
            border: none;
            outline: none;
            background-color: #f5f5f5;
            border-radius: 1rem;
            &:focus {
              border: none;
            }
          }
          .el-select__caret {
            &::before {
              content: '';
              display: inline-block;
              width: 1rem;
              height: .6rem;
              background: url(../../../assets/bx/sanjiao.png) no-repeat 0 0 / 100% 100%;
            }
          }
        }
        .el-form-item__error {
          left: 9.4rem;
          right: 0;
          top: 100%;
          margin-top: .2rem;
          font-size: 1.2rem;
          transform: none;
        }

        .el-input__inner {
          height: 4.4rem;
          font-size: 1.4rem;
          padding: 0 1.6rem;
          outline: none;
          appearance: none;

          &:focus {
            border: 1px solid #dcdee6;
          }
        }

        .code_area {
          width: 100%;
          height: 4.4rem;
          display: flex;
          align-items: center;
          border-radius: 4px;
          background-color: #fff;
          margin-top: 1.4rem;
          position: relative;

          &:hover {
            border-color: #c0c4cc;
          }

          .pre {
            position: absolute;
            left: 0;
            top: 0;
            width: 9rem;
            height: 100%;
            z-index: 1;
            display: flex;
            align-items: center;
            padding-left: 1.6rem;
            font-size: 1.4rem;
          }

          .el-input__inner {
            font-size: 1.4rem;
            height: 4.4rem;
            padding: 0 10rem;
          }

          .lwc_primary {
            position: absolute;
            right: 0.6rem;
            top: 50%;
            transform: translateY(-50%);
            -webkit-tap-highlight-color: transparent;
            border: none;
            color: var(--theme);
            font-size: 1.2rem;
            background-color: var(--xq);
            color: #fff;
            width: 8.5rem;
            height: 2.5rem;
            line-height: 2.5rem;
            display: flex;
            align-items: center;
            justify-content: center;

            &:visited,
            &:hover,
            &:active {
              opacity: 0.9;
            }

            &.is-disabled {
              background-color: #999;
            }
          }
        }

        .code_area ~ .el-form-item__error {
          top: -0.5rem;
        }
      }
    }
  }

  .tip {
    margin: 1.4rem 0 0;
    p {
      padding: 0 1rem;
      text-align: start;
      color: #aaa;
      margin-bottom: 0.4rem;
      i {
        color: var(--theme);
      }
    }
  }
  .bind_btns {
    margin-top: 1.4rem;
    display: flex;
    align-items: center;
    justify-content: center;
    .el-button {
      padding: 0;
      width: 100%;
      height: 5rem;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 10rem;
      font-size: 1.6rem;
    }
  }
}
#user_bind2 {
  .content {
    padding-top: 1.2rem;
    .box {
      background-color: #fff;
      border-radius: 1rem;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 2.8rem 0;
      .success {
        font-size: 5rem;
        color: var(--theme);
      }
      div {
        margin: 1.5rem 0;
        font-size: 1.6rem;
        color: #555;
      }
      p {
        font-size: 1.2rem;
        color: #999;
        line-height: 1.5;
      }
    }
  }
  .confirm {
    display: block;
    margin: 1rem auto 2rem;
    width: 100%;
    height: 4rem;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 10rem;
    font-size: 1.6rem;
  }
}
</style>
